export default __webpack_public_path__ + "static/media/desvantagem.d2edb9b6.png";